export default "__VITE_ASSET__D_dOy6ID__"